import styled from '@emotion/styled';
import { Link } from '~/shared/components/Link';
import { Text } from '~/shared/components/Text';
import { breakpoints } from '~/theme';

export const Section = styled.div(() => ({
    display: 'grid',
}));

export const AccountWrapper = styled.ul(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    background: theme.colors.offWhite,
    padding: theme.space[3],
    marginBottom: 2,

    [breakpoints.md]: {
        padding: theme.space[3],
        marginBottom: 2,
    },
}));

export const AccountTopWrapper = styled.div(({ theme }) => ({
    marginBottom: theme.space[6],
    overflowX: 'scroll',
    '::-webkit-scrollbar': {
        display: 'none',
    },
}));

export const AccountBottomWrapper = styled.div((props) => ({
    overflowX: 'scroll',
    '::-webkit-scrollbar': {
        display: 'none',
    },
}));

export const FirstColumn = styled.li(() => ({
    gridColumn: 1,
}));

export const SecondColumn = styled.li(() => ({
    gridColumn: 2,
    listStyle: 'none',
}));

export const ThirdColumn = styled.li(() => ({
    gridColumn: 3,
    listStyle: 'none',
    justifySelf: 'end',
}));

export const StyledText = styled(Text)(({ theme }) => ({
    color: theme.colors.grey70,
}));

export const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.colors.brandBlue,
    fontSize: theme.fontSizes.guinea,
    fontWeight: theme.fontWeights.medium,
    border: 'none',
    background: 'none',
}));

export const StyledLinkWithIcon = styled(Link)(({ theme }) => ({
    '--svg-width': theme.space[4],
    color: theme.colors.brandBlue,
    fontSize: theme.fontSizes.guinea,
    fontWeight: theme.fontWeights.medium,
    //don't break the text
    whiteSpace: 'nowrap',
    position: 'relative',
    textAlign: 'left',
    paddingBottom: 2,

    span: {
        span: {
            marginLeft: '0px',
        },
    },

    svg: {
        width: 'var(--svg-width)',
    },
    '&:after': {
        content: '""',
        position: 'absolute',
        right: 'var(--svg-width)',
        bottom: 2,
        height: '1px',
        width: 'calc(100% - var(--svg-width))',
        backgroundColor: theme.colors.brandBlue,
    },
    '&:hover:after, &:active:after, &:focus:after': {
        width: '0%',
        transition: 'width 0.3s ease-in-out',
    },
}));
